var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ModalMailConfirm'),_c('ModalMailConfirmReminder')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }